import { typesRedux } from '../../shared/types/typesRedux';
import jwt_decode from 'jwt-decode';

const initialState = {
    token: '',
    exp: null,
    expirationToken: false,
};

const decryptTokenExp = (token: any) => {
    const data: { exp: null } = jwt_decode(token) || null;
    let result = null;
    if (data?.exp) {
        result = new Date(data?.exp * 1000) || null;
    }
    return result;
};

export const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case typesRedux.AUTH_LOGIN:
            return {
                ...state,
                token: action.payload.token,
                exp: decryptTokenExp(action.payload.token),
            };

        case typesRedux.VALIDATION_TOKEN:
            return {
                ...state,
                expirationToken: true,
            };

        case typesRedux.LOGOUT_LOGIN:
            return {
                initialState,
            };

        default:
            return state;
    }
};
